import {PROGRESS_CHANGE, PROGRESS_CHANGE_NO} from './types'

export  function progressChange() {
    return function (dispatch) {
        dispatch ({type:PROGRESS_CHANGE})
    }
}


export const progressChangeNo = () => {
    return {
        type: PROGRESS_CHANGE_NO,
    };
};










